export enum InvoiceDataFields {
  fixed = 'Fixed',
  flexible_booked = 'Flexible (Booked)',
  flexible_offered = 'Flexible (Offered)',
  holidays = 'Holidays/Paid Leave',
  payment = 'Month’s Payment'
}
